import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 19391 19391"
    {...props}
  >
    <g id="Layer_x0020_1">
      <g id="_2528316982784">
        <path
          d="M1211 572l17089 0c352,0 639,288 639,639l0 4501 -18367 0 0 -4501c0,-351 287,-639 639,-639z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 1077.29,
          }}
        />
        <path
          d="M574 5970l3674 0 0 10945c0,1010 -827,1837 -1836,1837l-1 0c-1010,0 -1837,-827 -1837,-1837l0 -10945z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 1077.29,
          }}
        />
        <path
          d="M4245 5998l3673 0 0 10945c0,1010 -826,1837 -1836,1837l0 0c-1011,0 -1837,-827 -1837,-1837l0 -10945z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 1077.29,
          }}
        />
        <path
          d="M7918 5998l3674 0 0 10945c0,1010 -827,1837 -1837,1837l0 0c-1010,0 -1837,-827 -1837,-1837l0 -10945z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 1077.29,
          }}
        />
        <path
          d="M11595 6085l3673 0 0 10944c0,1011 -826,1837 -1836,1837l0 0c-1011,0 -1837,-826 -1837,-1837l0 -10944z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 1077.29,
          }}
        />
        <path
          d="M15268 6160l3674 0 0 10944c0,1011 -827,1837 -1837,1837l0 0c-1011,0 -1837,-826 -1837,-1837l0 -10944z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 1077.29,
          }}
        />
      </g>
    </g>
  </svg>
);

export default SvgComponent;